"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Formatter = exports["default"] = /*#__PURE__*/function () {
  function Formatter() {
    _classCallCheck(this, Formatter);
  }
  return _createClass(Formatter, null, [{
    key: "getInitials",
    value: function getInitials(user) {
      try {
        var firstName = user.firstName,
          lastName = user.lastName;
        if (firstName && lastName) {
          return firstName[0].toUpperCase() + lastName[0].toUpperCase();
        }
      } catch (e) {
        return '';
      }
      return '';
    }

    /**
     * Helper function that takes a date and outputs a string formatted to "h:mm".
     * 
     * @param {Date} date a date to be formatted
     * @returns {string} The "h:mm[am/pm]" formatted string (example: 8:45pm)
     */
  }, {
    key: "getFormattedTimeStr",
    value: function getFormattedTimeStr(date) {
      var dateSplit = new Date(date).toString().split(' '),
        dateStr = dateSplit[4],
        dateArr = dateStr.split(':'),
        dateIndex = dateArr[0].startsWith('0') ? 1 : 0,
        dateAMPM = dateIndex === 1 ? 'am' : 'pm';
      return "".concat(dateArr[0].substring(dateIndex), ":").concat(dateArr[1]).concat(dateAMPM);
    }

    /**
     * Helper function that takes a date and outputs a string formatted to 
     * "MMM d yyy".
     * 
     * @param {Date} date a date from which a formatted string will be returned
     * @returns {string} The "MMM d yyy" formatted string (example: Jul 2 2018)
     */
  }, {
    key: "getFormattedDate",
    value: function getFormattedDate(date) {
      var dateSplit = new Date(date).toString().split(' '),
        dateIndex = dateSplit[2].startsWith('0') ? 1 : 0;
      return "".concat(dateSplit[1], " ").concat(dateSplit[2].substring(dateIndex), " ").concat(dateSplit[3]);
    }
  }]);
}();